<svg
  id="ea0hEJFG8DO1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 400 400"
  shape-rendering="geometricPrecision"
  text-rendering="geometricPrecision"
  width="400"
  height="400"
>
  <g id="ea0hEJFG8DO2_to" transform="translate(200.000008,226.853312)">
    <g id="ea0hEJFG8DO2_ts" transform="scale(0,0)">
      <g id="ea0hEJFG8DO2" transform="translate(-200.000008,-199.949997)" opacity="0">
        <g>
          <g>
            <path
              d="M269.4,200c0,9.7,7,17.7,16.2,19.3c2,.3,3.4,2,3.4,4v22.8c0,2.3-1.8,4.1-4.1,4.1h-170c-2.3,0-4.1-1.8-4.1-4.1v-22.8c0-2,1.4-3.7,3.4-4c9.2-1.6,16.2-9.7,16.2-19.3c0-9.7-7-17.7-16.2-19.3-2-.3-3.4-2-3.4-4v-22.8c0-2.3,1.8-4.1,4.1-4.1h170c2.3,0,4.1,1.8,4.1,4.1v22.8c0,2-1.4,3.7-3.4,4-9.2,1.6-16.2,9.6-16.2,19.3Z"
              fill="#f9b233"
            />
            <path
              d="M289.1,162.3L111,162.2v-8c0-2.5,2.1-4.6,4.6-4.6h169c2.5,0,4.6,2.1,4.6,4.6l-.1,8.1Z"
              fill="#f39200"
            />
            <path d="M284.5,250.3h-169c-2.5,0-4.6-2.1-4.6-4.6v-8l178.1.1v8c0,2.5-2,4.5-4.5,4.5Z" fill="#f39200" />
          </g>
          <g id="ea0hEJFG8DO8_ts" transform="translate(200.137337,200.012299) scale(0,0)">
            <path
              d="M201.9,174.6l5.3,16.2c.3.8,1,1.4,1.9,1.4h17c1.9,0,2.7,2.4,1.2,3.6l-13.8,10c-.7.5-1,1.4-.7,2.2l5.3,16.2c.6,1.8-1.5,3.3-3,2.2l-13.8-10c-.7-.5-1.6-.5-2.3,0l-13.8,10c-1.5,1.1-3.6-.4-3-2.2l5.3-16.2c.3-.8,0-1.7-.7-2.2l-13.8-10c-1.5-1.1-.8-3.6,1.2-3.6h17c.9,0,1.6-.6,1.9-1.4l5.3-16.2c.3-1.8,2.9-1.8,3.5,0Z"
              transform="translate(-200.137337,-200.012299)"
              fill="#f39200"
            />
          </g>
        </g>
      </g>
    </g>
  </g>
  <g id="ea0hEJFG8DO9_to" transform="translate(180.754418,453.104701)">
    <g id="ea0hEJFG8DO9_tr" transform="rotate(0)">
      <g transform="translate(-110.89999,-328.520721)">
        <g>
          <g>
            <path
              d="M78.1,345c-2.3-4.6-7.5-6.7-12.3-5.3-1,.3-2.1-.1-2.6-1.1l-5.4-10.8c-.5-1.1-.1-2.4,1-2.9l80.4-40.4c1.1-.5,2.4-.1,2.9,1l5.4,10.8c.5.9.2,2.1-.7,2.7-4,3-5.4,8.4-3.1,13s7.5,6.7,12.3,5.3c1-.3,2.1.1,2.6,1.1l5.4,10.8c.5,1.1.1,2.4-1,2.9L82.6,372.5c-1.1.5-2.4.1-2.9-1l-5.4-10.8c-.5-.9-.2-2.1.7-2.7c4-2.9,5.4-8.4,3.1-13Z"
              fill="#f9b233"
            />
            <path
              d="M77.7,367.5L162,325.2l1.9,3.8c.6,1.2.1,2.7-1.1,3.3L82.9,372.5c-1.2.6-2.7.1-3.3-1.1l-1.9-3.9Z"
              fill="#f39200"
            />
            <path
              d="M59,324.8l79.9-40.2c1.2-.6,2.7-.1,3.3,1.1l1.9,3.8-84.3,42.3-1.9-3.8c-.6-1.1-.1-2.6,1.1-3.2Z"
              fill="#f39200"
            />
          </g>
          <path
            d="M116.1,341l-6.3-6.4c-.3-.3-.8-.4-1.2-.2l-8.1,4.1c-.9.5-1.9-.5-1.4-1.4l4.1-8c.2-.4.1-.9-.2-1.2l-6.3-6.4c-.7-.7-.1-1.9.9-1.8l8.9,1.5c.4.1.9-.1,1.1-.6l4.1-8c.5-.9,1.8-.7,2,.3l1.4,8.9c.1.4.4.8.9.9l8.9,1.5c1,.2,1.2,1.5.3,2l-8.1,4.1c-.4.2-.6.6-.6,1.1l1.4,8.9c.1.8-1.1,1.4-1.8.7Z"
            fill="#f39200"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ea0hEJFG8DO16_to" transform="translate(180.940149,453.910503)">
    <g id="ea0hEJFG8DO16_tr" transform="rotate(0)">
      <g transform="translate(-235.700005,-328.449997)">
        <g>
          <g>
            <path
              d="M256.7,351.1c-3.1,2.9-3.6,7.6-1.4,11.1.5.7.4,1.7-.3,2.3l-7.4,6.9c-.7.7-1.9.6-2.6-.1L193.7,316c-.7-.7-.6-1.9.1-2.6l7.4-6.9c.6-.6,1.6-.6,2.3-.1c3.3,2.5,8,2.4,11.2-.6c3.1-2.9,3.6-7.6,1.4-11.1-.5-.7-.4-1.7.3-2.3l7.4-6.9c.7-.7,1.9-.6,2.6.1l51.3,55.3c.7.7.6,1.9-.1,2.6l-7.4,6.9c-.6.6-1.6.6-2.3.1-3.3-2.5-8.1-2.3-11.2.6Z"
              fill="#f9b233"
            />
            <path
              d="M274.9,346.1l-53.8-57.9l2.6-2.4c.8-.8,2.1-.7,2.9.1l51,54.9c.8.8.7,2.1-.1,2.9l-2.6,2.4Z"
              fill="#f39200"
            />
            <path
              d="M244.9,371.2l-51-54.9c-.8-.8-.7-2.1.1-2.9l2.6-2.4l53.8,57.9-2.6,2.4c-.9.7-2.2.7-2.9-.1Z"
              fill="#f39200"
            />
          </g>
          <path
            d="M244.5,321.5l-3.7,6.6c-.2.3-.1.7.1,1l5.1,5.5c.6.6,0,1.6-.8,1.5l-7.4-1.5c-.4-.1-.7.1-.9.4l-3.7,6.6c-.4.7-1.5.5-1.6-.3l-.9-7.5c0-.4-.3-.7-.7-.8l-7.4-1.5c-.8-.2-1-1.3-.2-1.7l6.9-3.2c.3-.2.5-.5.5-.9l-.9-7.5c-.1-.8.9-1.3,1.5-.7l5.1,5.5c.3.3.7.4,1,.2l6.9-3.2c.8-.1,1.6.7,1.1,1.5Z"
            fill="#f39200"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ea0hEJFG8DO23_to" transform="translate(193.892792,449.783972)">
    <g id="ea0hEJFG8DO23_tr" transform="rotate(0)">
      <g transform="translate(-348.950012,-281.349983)">
        <g>
          <g>
            <path
              d="M333,307.7c-3.7-2.2-8.3-1.4-11.1,1.7-.6.7-1.6.8-2.3.4l-8.7-5.2c-.9-.5-1.1-1.6-.6-2.5l39.1-64.5c.5-.9,1.6-1.1,2.5-.6l8.7,5.2c.8.5,1.1,1.4.7,2.2-1.5,3.9-.1,8.4,3.6,10.6s8.3,1.4,11.1-1.7c.6-.7,1.6-.8,2.3-.4l8.7,5.2c.9.5,1.1,1.6.6,2.5l-39.1,64.5c-.5.9-1.6,1.1-2.5.6l-8.7-5.2c-.8-.5-1.1-1.4-.7-2.2c1.5-3.9,0-8.4-3.6-10.6Z"
              fill="#f9b233"
            />
            <path
              d="M342.7,323.8l41-67.6l3,1.8c1,.6,1.3,1.8.7,2.8L348.6,325c-.6,1-1.8,1.3-2.8.7l-3.1-1.9Z"
              fill="#f39200"
            />
            <path
              d="M310.4,301.8l38.9-64.1c.6-1,1.8-1.3,2.8-.7l3,1.8-41,67.6-3-1.8c-1-.5-1.3-1.8-.7-2.8Z"
              fill="#f39200"
            />
          </g>
          <path
            d="M358.1,287.9l-7.4-1.7c-.4-.1-.8.1-.9.4l-3.9,6.5c-.4.7-1.6.5-1.6-.4l-.6-7.5c0-.4-.3-.7-.7-.8l-7.4-1.7c-.8-.2-.9-1.3-.1-1.7l7-2.9c.3-.1.6-.5.5-.9l-.6-7.5c-.1-.8,1-1.3,1.5-.6l4.9,5.7c.2.3.7.4,1,.2l7-2.9c.8-.3,1.5.5,1.1,1.3l-3.9,6.5c-.2.3-.2.7.1,1l4.9,5.7c.5.5,0,1.5-.9,1.3Z"
            fill="#f39200"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ea0hEJFG8DO30_to" transform="translate(186.221951,464.053243)">
    <g id="ea0hEJFG8DO30_tr" transform="rotate(0)">
      <g transform="translate(-54.698263,-244.300034)">
        <g>
          <g>
            <path
              d="M49.9,274.5c-4.2-.7-8.2,1.8-9.5,5.7-.3.8-1.1,1.3-2,1.2l-9.9-1.6c-1-.2-1.7-1.1-1.5-2.1l11.6-73.9c.2-1,1.1-1.7,2.1-1.5l9.9,1.6c.9.1,1.5.9,1.5,1.8.1,4.1,3.1,7.7,7.3,8.4s8.2-1.8,9.5-5.7c.3-.8,1.1-1.3,2-1.2l9.9,1.6c1,.2,1.7,1.1,1.5,2.1L70.7,284.8c-.2,1-1.1,1.7-2.1,1.5l-9.9-1.6c-.9-.1-1.5-.9-1.5-1.8-.1-4.1-3.1-7.7-7.3-8.4Z"
              fill="#f9b233"
            />
            <path
              d="M65,285.7l12.2-77.5l3.5.5c1.1.2,1.9,1.2,1.7,2.3L70.9,284.5c-.2,1.1-1.2,1.9-2.3,1.7l-3.6-.5Z"
              fill="#f39200"
            />
            <path
              d="M27,277.6l11.5-73.5c.2-1.1,1.2-1.9,2.3-1.7l3.5.5-12.2,77.5-3.5-.5c-1-.1-1.8-1.1-1.6-2.3Z"
              fill="#f39200"
            />
          </g>
          <path
            d="M65.6,246.9l-7.4,1.2c-.4.1-.7.4-.7.7l-1.2,7.4c-.1.8-1.2,1-1.6.3l-3.4-6.7c-.2-.3-.5-.5-.9-.5L43,250.5c-.8.1-1.3-.9-.8-1.5l5.3-5.3c.3-.3.3-.7.2-1L44.3,236c-.4-.7.4-1.6,1.2-1.2l6.7,3.4c.3.2.7.1,1-.2l5.3-5.3c.6-.6,1.6-.1,1.5.7l-1.2,7.4c-.1.4.1.7.5.9l6.7,3.4c.6.5.4,1.7-.4,1.8Z"
            fill="#f39200"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ea0hEJFG8DO37_to" transform="translate(258.381487,451.279486)">
    <g id="ea0hEJFG8DO37_tr" transform="rotate(0)">
      <g transform="translate(-54.698263,-244.300034)">
        <g>
          <g>
            <path
              d="M49.9,274.5c-4.2-.7-8.2,1.8-9.5,5.7-.3.8-1.1,1.3-2,1.2l-9.9-1.6c-1-.2-1.7-1.1-1.5-2.1l11.6-73.9c.2-1,1.1-1.7,2.1-1.5l9.9,1.6c.9.1,1.5.9,1.5,1.8.1,4.1,3.1,7.7,7.3,8.4s8.2-1.8,9.5-5.7c.3-.8,1.1-1.3,2-1.2l9.9,1.6c1,.2,1.7,1.1,1.5,2.1L70.7,284.8c-.2,1-1.1,1.7-2.1,1.5l-9.9-1.6c-.9-.1-1.5-.9-1.5-1.8-.1-4.1-3.1-7.7-7.3-8.4Z"
              fill="#f9b233"
            />
            <path
              d="M65,285.7l12.2-77.5l3.5.5c1.1.2,1.9,1.2,1.7,2.3L70.9,284.5c-.2,1.1-1.2,1.9-2.3,1.7l-3.6-.5Z"
              fill="#f39200"
            />
            <path
              d="M27,277.6l11.5-73.5c.2-1.1,1.2-1.9,2.3-1.7l3.5.5-12.2,77.5-3.5-.5c-1-.1-1.8-1.1-1.6-2.3Z"
              fill="#f39200"
            />
          </g>
          <path
            d="M65.6,246.9l-7.4,1.2c-.4.1-.7.4-.7.7l-1.2,7.4c-.1.8-1.2,1-1.6.3l-3.4-6.7c-.2-.3-.5-.5-.9-.5L43,250.5c-.8.1-1.3-.9-.8-1.5l5.3-5.3c.3-.3.3-.7.2-1L44.3,236c-.4-.7.4-1.6,1.2-1.2l6.7,3.4c.3.2.7.1,1-.2l5.3-5.3c.6-.6,1.6-.1,1.5.7l-1.2,7.4c-.1.4.1.7.5.9l6.7,3.4c.6.5.4,1.7-.4,1.8Z"
            fill="#f39200"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ea0hEJFG8DO44_to" transform="translate(179.438232,455.092266)">
    <g id="ea0hEJFG8DO44_tr" transform="rotate(0)">
      <g transform="translate(-312.150909,-361.399963)">
        <g>
          <g>
            <path
              d="M315.4,384.3c-3.2.5-5.5,3.1-5.6,6.3c0,.7-.5,1.2-1.2,1.3l-7.5,1.1c-.7.1-1.4-.4-1.5-1.2l-7.9-56.1c-.1-.7.4-1.4,1.2-1.5l7.5-1.1c.7-.1,1.3.3,1.5.9c1,3,3.9,4.9,7.1,4.5c3.2-.5,5.5-3.1,5.6-6.3c0-.7.5-1.2,1.2-1.3l7.5-1.1c.7-.1,1.4.4,1.5,1.2l7.9,56.1c.1.7-.4,1.4-1.2,1.5l-7.5,1.1c-.7.1-1.3-.3-1.5-.9-.9-3-3.9-5-7.1-4.5Z"
              fill="#f9b233"
            />
            <path
              d="M328.8,389l-8.3-58.8l2.6-.4c.8-.1,1.6.5,1.7,1.3l7.9,55.8c.1.8-.5,1.6-1.3,1.7l-2.6.4Z"
              fill="#f39200"
            />
            <path
              d="M299.5,391.6l-7.9-55.8c-.1-.8.5-1.6,1.3-1.7l2.6-.4l8.3,58.8-2.6.4c-.8.1-1.6-.5-1.7-1.3Z"
              fill="#f39200"
            />
          </g>
          <path
            d="M320.6,360.8l-5.1,2.5c-.3.1-.4.4-.4.7l.8,5.6c.1.6-.7,1-1.1.6l-4-4.1c-.2-.2-.5-.3-.8-.1l-5.1,2.5c-.6.3-1.2-.3-.9-.9l2.7-5c.1-.3.1-.6-.1-.8l-4-4.1c-.4-.5,0-1.2.6-1.1l5.6,1c.3,0,.6-.1.7-.3l2.7-5c.3-.6,1.1-.4,1.2.2l.8,5.6c0,.3.3.5.5.6l5.6,1c.8-.1.9.8.3,1.1Z"
            fill="#f39200"
          />
        </g>
      </g>
    </g>
  </g>
</svg>
